/**
 * Serviço de comunicação com o aplicativo Android nativo
 *
 * Eventos disponíveis:
 * - im-route-changed: Navegação para uma rota POS
 *   Enviado de: router/index.js (beforeEach)
 *   Dados: { screen, routeName, path, query: { darkMode, pos } }
 *
 * - im-contract-loaded-successfully: Tela carregada com sucesso
 *   Enviado de: Login.vue, NewPOS.vue
 *   Dados: { screen, username, readyForInput, darkMode, ... }
 *
 * - im-contract-loaded-error: Erro ao carregar a tela
 *   Enviado de: Login.vue
 *   Dados: { screen, errorType, ... }
 *
 * - im-user-logged-in: Usuário fez login com sucesso
 *   Enviado de: Login.vue (método login())
 *   Dados: { username, collaboratorId, loginTimestamp, darkMode }
 *
 * - im-navigate-to-new-contract: Navegando para tela de novo contrato
 *   Enviado de: Login.vue (após getFranchise)
 *   Dados: { screen, darkMode }
 *
 * - im-contract-creation-started: Começou a criar contrato
 *   Enviado de: NewPOS.vue (método createCheckout())
 *   Dados: { screen, userColaborador, documentsCount }
 *
 * - im-contract-created-successfully: Contrato criado com sucesso
 *   Enviado de: NewPOS.vue (após postCreateContract sucesso)
 *   Dados: { screen, contractId, userDocument, userName, userEmail, franchiseId, signUrl }
 *
 * - im-contract-created-error: Erro ao criar contrato
 *   Enviado de: NewPOS.vue (após postCreateContract erro)
 *   Dados: { screen, userDocument, errorMessage }
 *
 * - im-contract-payment-click: Iniciando processo de pagamento
 *   Enviado de: NewPOS.vue (método onPaymentClick())
 *   Dados: { screen, contractId, franchiseId, name, taxpayerId, studentName, courseName, personaType }
 */

export default {
  sendMessage(type, data = {}) {
    const payload = {
      type,
      data: {
        timestamp: new Date().toISOString(),
        ...data,
      },
    };

    try {
      if (window.Android) {
        try {
          window.Android.postMessage(JSON.stringify(payload));
          return true;
        } catch (e) {
          // Continua tentativas alternativas
        }
      }

      if (window.AndroidInterface) {
        window.AndroidInterface.postMessage(JSON.stringify(payload));
        return true;
      }

      if (window.parent && window.parent !== window) {
        let parentOrigin = '*';

        try {
          if (window.location.ancestorOrigins?.length) {
            parentOrigin = window.location.ancestorOrigins[0];
          } else if (document.referrer) {
            parentOrigin = new URL(document.referrer).origin;
          }
        } catch (e) {
          // mantém '*' como fallback se não for possível determinar a origem
        }

        window.parent.postMessage(payload, parentOrigin);

        return true;
      }

      // Fallback para ambiente de teste
      window.dispatchEvent(
        new CustomEvent('androidMessage', {
          detail: payload,
        })
      );
      return true;
    } catch (error) {
      console.error('[Android] Erro ao enviar mensagem:', {
        type,
        error: error.message,
        stack: error.stack,
      });
      return false;
    }
  },
};
